// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4099":"a83d2751","5646":"286bf7b9"}[chunkId] + ".chunk.css";
};